import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";

import saveIconWhite from "../../images/link.svg";
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tab: {
    textTransform: "none",
    fontSize: "0.75rem",
    minWidth: "0.02rem",
    backgroundColor: "transparent",
    opacity: 1,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="tabpanel"
      style={{ height: props.height }}
    >
      {value === index && children}
    </div>
  );
}

function TabMenu(props) {
  const classes = useStyles();
  const { id, labels, variant } = props;
  const [visibleTab, setVisibleTab] = useState(0);

  const handleTabs = (event, newValue) => {
    setVisibleTab(newValue);
  };

  return (
    <div className={"lead-tabs"}>
      <Tabs
        key={id}
        value={visibleTab}
        onChange={handleTabs}
        variant={variant}
        textColor="primary"
        indicatorColor="primary"
      >
        {labels.map((label, i) => (
          <Tab
            key={id + "-tab-" + i}
            disabled={props.loading || label.disabled}
            disableRipple
            label={label.label}
            classes={{ root: classes.tab, disabled: classes.tab }}
            style={label.showIcon ? {display: "flex", flexFlow: "row", gap: "1rem"} : {}}
            icon={label.showIcon
              ?
                <IconButton onClick={label.iconOnClick} >
                  <img src={label.iconSVG} alt={label.iconAlt} title={label.iconAlt} />
                </IconButton>
              : <></>}

            
          />
        ))}
      </Tabs>
      <div>
        {props.children.map((child, i) => (
          <TabPanel
            key={id + "-tabpanel-" + i}
            value={visibleTab}
            index={i}
            height={props.height}
          >
            {child}
          </TabPanel>
        ))}
      </div>
    </div>
  );
}

export { TabMenu };
